<script setup>

import { inject, ref, watch } from 'vue';
import { getErreurFichierRequis } from '@/scripts/controlesSaisie.js';
import { 
	apiRemplacerFichierExempleImport } from '@/services/ServiceModele.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieFichier from '@/components/generiques/SaisieFichier.vue';

const { importDonnees } = defineProps({
    importDonnees: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['modifFichier']);

const dernierFichierSelectionne = inject('dernierFichierSelectionne');
const appelerApiModifModele = inject('appelerApiModifModele');
const afficherSucces = inject('afficherSucces');

const importFichier = ref(getImportInitial());

watch(() => visible.value, (visible) => {
    if (visible) {
        importFichier.value.fichier = null;
    }
});

function getImportInitial() {
    return {
        fichier: null,
    };
}

function validerSaisie(importFichier) {
    const erreurs = {};
    erreurs.fichier = getErreurFichierRequis(importFichier.fichier);
    return erreurs;
}

function validerFormulaire() {
    importFichier.value.validationFormulaire = true;
}

function remplacerFichierExemple() {
    appelerApiModifModele(apiRemplacerFichierExempleImport, importDonnees, importFichier.value.fichier, (reponseOK) => {
        visible.value = false;
        if (reponseOK) {
            afficherSucces('Import terminé');
            dernierFichierSelectionne.value = importFichier.value.fichier;
            emit('modifFichier');
        }
    });
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        :header="'Nouveau fichier d\'exemple d\'un import'">
            <Formulaire
                :objet="importFichier"
                :fonction-validation-saisie="validerSaisie"
                @validation="remplacerFichierExemple">
                <label class="intitule">Modèle d'import :</label>
                <label>{{ importDonnees.libelle }}</label>
                <label class="intitule">Fichier :</label>
                <SaisieFichier v-model:valeur="importFichier.fichier" :id-erreur="'fichier'" />
            </Formulaire>
            <template #footer>
                <button 
                    class="bouton fas fa-check btn-primaire" 
                    @click="validerFormulaire()"/>
            </template>
    </Dialog>
</template>

<style scoped>

</style>